import React, { useCallback, useEffect, useState } from "react";
import styles from "../manage-access.module.scss";
import {
  CustomTabPanel,
  CustomTabs,
} from "../../../components/blocks/CustomTabs";
import { SelectRoles } from "./SelectRoles";
import { SelectUser } from "./SelectUser";
import { getActiveItemData, getRolesData } from "./services";
import { Employee, Role } from "../../../types";
import { ActiveType, SelectedObjType } from "../types";

type ManageAccessSelectType = {
  selectedObj: SelectedObjType;
  setSelectedObj: (n: SelectedObjType) => void;
  resetActiveItemId: () => void;
  activeItem: ActiveType;
  resetSelectedObj: () => void;
};

export const ManageAccessSelect = ({
  selectedObj,
  setSelectedObj,
  resetSelectedObj,
  resetActiveItemId,
  activeItem,
}: ManageAccessSelectType) => {
  const [activeTabId, setActiveTabId] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [roles, setRoles] = useState<Role[]>(null);
  const [activeItemUsers, setActiveItemUsers] = useState<Employee[] | null>(
    null,
  );

  const getRoles = useCallback(async () => {
    const res = await getRolesData(setIsFetching);
    setRoles(res);
  }, []);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const handleTabChange = (e, id) => {
    setActiveTabId(id);
  };

  const getActiveItem = useCallback(async () => {
    const { roles, users } = await getActiveItemData(activeItem, setIsFetching);
    setRoles(roles);
    setActiveItemUsers(users?.length ? users : null);
  }, [activeItem]);

  useEffect(() => {
    getActiveItem();
  }, [getActiveItem]);

  const handleChangeRolesData = useCallback(
    (newRoles: Role[]) => setRoles(newRoles),
    [],
  );

  const resetData = async () => {
    if (!activeItem?.grant_id && !activeItem?.menu_id) return;
    resetActiveItemId();
    setActiveItemUsers(null);
    await getRoles();
  };

  return (
    <div className={styles.manage__select}>
      <CustomTabs
        disabled={!activeTabId}
        onChange={handleTabChange}
        value={activeTabId}
        tabs={tabs}
      />
      <div className={styles.manage__select_content}>
        <CustomTabPanel value={activeTabId} index={0}>
          <SelectRoles
            isFetching={isFetching}
            setSelectedObj={setSelectedObj}
            selectedObj={selectedObj}
            resetData={resetData}
            resetSelectedObj={resetSelectedObj}
            data={roles}
            handleChangeRolesData={handleChangeRolesData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={activeTabId} index={1}>
          <SelectUser
            selectedObj={selectedObj}
            isFetching={isFetching}
            setSelectedObj={setSelectedObj}
            activeItemUsers={activeItemUsers}
            resetData={resetData}
          />
        </CustomTabPanel>
      </div>
    </div>
  );
};
const tabs = [
  { label: "Роли", key: "roles" },
  { label: "Сотрудники", key: "users" },
];
